import { render, staticRenderFns } from "./SelectCasePage.vue?vue&type=template&id=79b0c14e&scoped=true"
import script from "./SelectCasePage.vue?vue&type=script&lang=ts"
export * from "./SelectCasePage.vue?vue&type=script&lang=ts"
import style0 from "./SelectCasePage.vue?vue&type=style&index=0&id=79b0c14e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0c14e",
  null
  
)

export default component.exports